export function readProcessorUrlState(search) {
  const params = new URLSearchParams(
    search instanceof URLSearchParams ? search : search || ''
  );
  const processorId = params.get('p');
  const fromId = params.get('from');
  return {
    processorId: processorId ? String(processorId) : null,
    add: params.get('add') === '1',
    fromId: fromId ? String(fromId) : null,
  };
}

export function writeProcessorUrlState(currentSearch, patch = {}) {
  const params = new URLSearchParams(
    currentSearch instanceof URLSearchParams ? currentSearch : currentSearch || ''
  );
  if (Object.prototype.hasOwnProperty.call(patch, 'processorId')) {
    if (patch.processorId) params.set('p', String(patch.processorId));
    else params.delete('p');
  }
  if (Object.prototype.hasOwnProperty.call(patch, 'add')) {
    if (patch.add) params.set('add', '1');
    else params.delete('add');
  }
  if (Object.prototype.hasOwnProperty.call(patch, 'fromId')) {
    if (patch.fromId) params.set('from', String(patch.fromId));
    else params.delete('from');
  }
  if (params.get('add') !== '1') params.delete('from');
  return params;
}
